import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import FindYourBalance from "./sections/FindYourBalance";
import DualCityCareCenters from "./sections/DualCityCareCenters";
import EfficiencyCeilingAnalysis from "./sections/EfficiencyCeilingAnalysis";
import TheSmileCraftWay from "./sections/TheSmileCraftWay";
import ModalitiesOfCare from "./sections/ModalitiesOfCare";
import VoicesOfRecovery from "./sections/VoicesOfRecovery";
import ReadyForTheNextLevel from "./sections/ReadyForTheNextLevel";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <FindYourBalance />
      <DualCityCareCenters />
      <EfficiencyCeilingAnalysis />
      <TheSmileCraftWay />
      <ModalitiesOfCare />
      <VoicesOfRecovery />
      <ReadyForTheNextLevel />
      <Footer />
    </div>;
}